export function PageSpinner() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center bg-base-deepest">
      <span className="h-8 w-8 animate-spin rounded-full border-4 border-accent-violet border-t-transparent" />
    </div>
  );
}
